import React from 'react';
import { Star } from 'lucide-react';
const testimonials = [{
  name: 'Camila Rodríguez',
  location: 'Córdoba, Capital',
  age: '29 años',
  text: 'Siempre quise dedicarme a la estética pero los cursos presenciales eran impagables. Con este pack aprendí a hacer lifting de pestañas y perfilado. Ya tengo mis primeras 5 clientas fijas y recuperé la inversión en una semana.',
  initial: 'C'
}, {
  name: 'Valeria Benítez',
  location: 'Rosario, Santa Fe',
  age: '34 años',
  text: 'Soy mamá de dos nenes y necesitaba trabajar desde casa. El módulo de manicuría es excelente, súper detallado. Empecé practicando con amigas y ahora ya cobro por el servicio. La guía de precios me salvó.',
  initial: 'V'
}, {
  name: 'Sofía Martínez',
  location: 'La Plata, Buenos Aires',
  age: '26 años',
  text: 'Tenía miedo de que fuera pura teoría, pero es súper práctico. Lo que más me sirvió fue la parte de bioseguridad y cómo armar el gabinete. Me dio la confianza que me faltaba para arrancar.',
  initial: 'S'
}, {
  name: 'Andrea Gómez',
  location: 'Mendoza',
  age: '41 años',
  text: 'Trabajé 15 años en comercio y quería un cambio. Compré el pack por el curso de Microneedling y me sorprendió la calidad. Ya estoy ofreciendo tratamientos faciales a domicilio y gano más que en mi antiguo trabajo.',
  initial: 'A'
}, {
  name: 'Luciana Fernández',
  location: 'Mar del Plata',
  age: '31 años',
  text: 'Lo compré por los bonos de regalo y terminé amando todo el contenido. La asesoría de imagen me ayudó a presentarme mejor ante las clientas. Es una inversión mínima para todo lo que trae.',
  initial: 'L'
}];
export function TestimonialsSection() {
  return <section className="py-20 bg-[#FDF2F8]" data-id="element-252">
      <div className="max-w-6xl mx-auto px-4" data-id="element-253">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12" data-id="element-254">
          Ellas ya están generando ingresos con el MegaPack 👇
        </h2>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-255">
          {testimonials.map((t, idx) => <div key={idx} className="bg-white p-6 rounded-lg shadow-md border border-pink-100" data-id="element-256">
              <div className="flex items-center gap-1 mb-4" data-id="element-257">
                {[1, 2, 3, 4, 5].map(s => <Star key={s} className="w-4 h-4 text-yellow-400 fill-current" data-id="element-258" />)}
              </div>
              <p className="text-gray-700 mb-6 italic" data-id="element-259">"{t.text}"</p>
              <div className="flex items-center gap-3" data-id="element-260">
                <div className="w-10 h-10 bg-pink-100 rounded-full flex items-center justify-center font-bold text-pink-600" data-id="element-261">
                  {t.initial}
                </div>
                <div data-id="element-262">
                  <p className="font-bold text-gray-900 text-sm" data-id="element-263">{t.name}</p>
                  <p className="text-xs text-gray-500" data-id="element-264">
                    {t.location} • {t.age}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}